import { set, when } from 'cerebral/operators'
import { props, state } from 'cerebral/tags'

export default [
  set(state`app.dialog.checkOption.value`, props`value`),
  when(props`value`),
  {
    true: [set(state`node.moveAlertTime.date`, new Date().getTime())],
    false: [set(state`node.moveAlertTime.date`, null)]
  }
]



// WEBPACK FOOTER //
// ./src/modules/App/chains/setDialogCheckvalue.js